import { Link } from "react-router-dom"
import DarkMode from "./DarkMode"
import { motion,stagger } from "framer-motion"
import { useState } from "react"

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2
    }
  }
}
  
const item = {
  hidden: {
    y: 20,
    opacity: 0,
    scale:1
  },
  
  visible: {
    y: 0,
    opacity: 1,
    scale: 1.1,
  }
}




const handleHover = () => {
  alert("you have to be the admin to login")
}

const Navbar = () => {

  const [open,setOpen] = useState(false)
  
  return (
    <header>
      <div className="container">
        <a className="navbar-brand fw-bold" href="/">adel</a>
        <motion.ul className={open ? "fa-bars-open" : "fa-bars-close"} variants={container} initial="hidden" animate="visible">
          {!open && <DarkMode variants={item} />}
          {open && <div className="ul-container ">
            <motion.li variants={item} transition={{delay:0.2}} >
              <Link className="" aria-current="page" to="/" onClick={() => setOpen(false)}>Home</Link>
            </motion.li>
            <motion.li variants={item} transition={{delay:0.3}} >
              <Link className="nav-link" to="/about" onClick={() => setOpen(false)}>about</Link>
            </motion.li>
            <motion.li variants={item} transition={{delay:0.4}} >
              <Link className="nav-link" to="/my-works" onClick={() => setOpen(false)}>portfolio</Link>
            </motion.li>
            <motion.li variants={item} transition={{delay:0.5}} >
              <Link className="nav-link" to="/login" onClick={handleHover} >login</Link>
            </motion.li>
              
              
              
          </div>}
        </motion.ul>
        <i className="fa-solid fa-bars" onClick={() => setOpen(!open)}></i>
      </div>
    </header>
  )
}

export default Navbar